import { darkTheme, lightTheme } from '../theme/themes';

/**
 * Sidebar panel colors contrast with the main content area.
 * - Light app theme: medium slate sidebar (darker than content, not near-black)
 * - Dark app theme: old app surface tones (lighter than page bg, bluish gray)
 */
export function getSidebarPanelColors(themeName, colors) {
  if (themeName === 'light') {
    return {
      bg: lightTheme.sidebarBg,
      bgFooter: lightTheme.sidebarBgFooter,
      border: lightTheme.sidebarBorder,
      text: darkTheme.text,
      textLight: darkTheme.textLight,
      textMuted: darkTheme.textMuted,
      primary: colors.primary,
    };
  }
  if (themeName === 'dark') {
    return {
      bg: darkTheme.sidebarBg,
      bgFooter: darkTheme.sidebarBgFooter,
      border: darkTheme.sidebarBorder,
      text: darkTheme.text,
      textLight: darkTheme.textLight,
      textMuted: darkTheme.textMuted,
      primary: colors.primary,
    };
  }
  return {
    bg: colors.bgSecondary,
    bgFooter: colors.bgPrimary,
    border: colors.border,
    text: colors.text,
    textLight: colors.textLight,
    textMuted: colors.textMuted,
    primary: colors.primary,
  };
}
